import { ntTestimonials as mockTestimonials } from "@/mocks/newtechData";
import { useTestimonials } from "@/hooks/useSupabaseData";

export default function NTTestimonials() {
  const { testimonials, loading } = useTestimonials();
  const items = testimonials.length > 0
    ? testimonials.map((t) => ({ id: t.id, name: t.author, role: t.role ?? "", company: t.company ?? "", text: t.text, avatar: t.avatar_url ?? mockTestimonials[0]?.avatar, rating: t.rating }))
    : mockTestimonials.map((t) => ({ ...t, rating: 5 }));

  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-[#3FA7D6] font-bold text-sm uppercase tracking-widest mb-1">Depoimentos</p>
          <h2 className="font-rajdhani font-bold text-[#1B1F5E] text-4xl md:text-5xl">O que nossos clientes dizem</h2>
        </div>
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {[1,2,3,4].map((i) => <div key={i} className="border border-gray-200 rounded-lg p-7 animate-pulse"><div className="flex gap-1 mb-4">{[1,2,3,4,5].map((s) => <div key={s} className="w-4 h-4 bg-gray-100 rounded"/>)}</div><div className="h-3 bg-gray-100 rounded w-full mb-2"/><div className="h-3 bg-gray-100 rounded w-5/6 mb-5"/><div className="flex items-center gap-3"><div className="w-11 h-11 rounded-full bg-gray-100"/><div className="space-y-1"><div className="h-4 bg-gray-100 rounded w-28"/><div className="h-3 bg-gray-100 rounded w-20"/></div></div></div>)}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {items.map((t) => (
              <div key={t.id} className="border border-gray-200 rounded-lg p-7 hover:border-[#3FA7D6] transition-all">
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(t.rating ?? 5)].map((_, i) => <i key={i} className="ri-star-fill text-[#3FA7D6] text-sm"></i>)}
                </div>
                <p className="text-[#555] text-sm leading-relaxed mb-5 italic">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 border-2 border-[#3FA7D6]/30">
                    {t.avatar ? <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top"/> : <div className="w-full h-full bg-[#1B1F5E]/10 flex items-center justify-center"><i className="ri-user-line text-[#1B1F5E]"></i></div>}
                  </div>
                  <div>
                    <p className="font-rajdhani font-bold text-[#1B1F5E] text-base">{t.name}</p>
                    <p className="text-[#999] text-xs">{t.role}{t.company ? ` — ${t.company}` : ""}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
